/**
 * Generated runtime TestId mirror for frontend/src/pages/NotificationTemplates.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const NotificationTemplatesTestIds = {
  badgeCustomised: "badge-customised",
  badgeDefault: "badge-default",
  colActive: "col-active",
  colKey: "col-key",
  colLastModified: "col-last-modified",
  colState: "col-state",
  colSubject: "col-subject",
  notificationTemplatesList: "notification-templates-list",
  notificationTemplatesTable: "notification-templates-table",
  notificationTemplateRow: (template_templateKey: string) => `notification-template-row-${template_templateKey}`,
  notificationTemplateRowPrefix: () => "notification-template-row-" as TestIdPrefix,
  templateSubject: (template_templateKey: string) => `template-subject-${template_templateKey}`,
  templateSubjectPrefix: () => "template-subject-" as TestIdPrefix
} as const;
